import { render, staticRenderFns } from "./bread-system-auth.vue?vue&type=template&id=fd84a2f8&scoped=true"
import script from "./bread-system-auth.vue?vue&type=script&lang=js"
export * from "./bread-system-auth.vue?vue&type=script&lang=js"
import style0 from "./bread-system-auth.vue?vue&type=style&index=0&id=fd84a2f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd84a2f8",
  null
  
)

export default component.exports